import { Typography } from '@mui/material'
import type { FC } from 'react'

import type { Squad } from '@/utils/squad'
import { toSquadLabel } from '@/utils/squad'

export interface Props {
  squad: Squad
}

const AppBarContent: FC<Props> = ({ squad }) => (
  <Typography component="h1" variant="h6">
    Squad: {toSquadLabel(squad)}
  </Typography>
)

export default AppBarContent
